import base from "common/js/base"; // 导入接口域名列表
import axios from "common/js/http"; // 导入 http中创建axios实例
// import qs from 'qs'; // 根据需求是否导入qs模块

const service = {
  // 登陆
  login(params) {
    return axios.post(`${base.web_lab}/login.php`, params)/* qs.stringify( */
  },
  // 获得市场人员
  getAllSalesman(params) {
    return axios.post(`${base.web_lab}/get_all_salesman.php`, params)
  },
  getSalesman(params) {
    return axios.post(`${base.web_lab}/get_salesman.php`, params)
  },
  // 修改市场人员的信息
  updateSalesman(params) {
    return axios.post(`${base.web_lab}/modify_user.php`, params)
  },
  // 删除人员信息
  deleteSalesman(params) {
    return axios.post(`${base.web_lab}/delete_user.php`, params)
  },
  // 搜索人员
  searchUser(params) {
    return axios.post(`${base.web_lab}/search_user.php`, params)
  },
  // 搜索订单条件
  searchIds(params) {
    return axios.post(`${base.web_lab}/search_ids.php`, params)
  },
  // 搜索订单
  searchOrders(params) {
    return axios.post(`${base.web_lab}/search_orders.php`, params)
  },
  orderExcel(params) {
    return axios.post(`${base.web_lab}/order_excel.php`, params)
  },
  // 获得消息 headerToP
  getMessages(params) {
    return axios.post(`${base.web_lab}/send_message.php`, params)
  },
  // 获得工程师人员信息
  getEngineer(params) {
    return axios.post(`${base.web_lab}/get_engineer.php`, params)
  },
  // 添加工程师的能力 /add_skill.php
  addSkill(params) {
    return axios.post(`${base.web_lab}/add_skill.php`, params)
  },
  // 添加工程师能做的仪器类型
  addType(params) {
    return axios.post(`${base.web_lab}/add_user_skill_class.php`, params)
  },
  //  搜索仪器 search_device.php
  skillSearch(params) {
    return axios.post(`${base.web_lab}/search_device.php`, params)
  },
  // 获取工程师 自己拥有的能力 user_info_skill.php
  userInfoSkill(params) {
    return axios.post(`${base.web_lab}/user_info_skill.php`, params)
  },
  // 工程师自己添加能够做的东西add_user_skill.php
  addUserSkill(params) {
    return axios.post(`${base.web_lab}/add_user_skill.php`, params)
  },
  // 工程师 删除自己所拥有的能力
  deleteUserSkill(params) {
    return axios.post(`${base.web_lab}/delete_user_skill.php`, params)
  },
  // 添加账户 save_user.php
  saveUser(params) {
    return axios.post(`${base.web_lab}/save_user.php`, params)
  },
  // 市场人员 customer_detail.php'
  customerDetail(params) {
    return axios.post(`${base.web_lab}/customer_detail.php`, params)
  },
  // 市场人员搜索客户信息  search_customer.php
  searchCustomer(params) {
    return axios.post(`${base.web_lab}/search_customer.php`, params)
  },
  // 删除 客户信息 delete_customer.php
  deleteCustomer(params) {
    return axios.post(`${base.web_lab}/delete_customer.php`, params)
  },
  // 修改各户信息 update_customer.php
  updateCustomer(params) {
    return axios.post(`${base.web_lab}/update_customer.php`, params)
  },
  // 添加客户信息add_customer.php
  addCustomer(params) {
    return axios.post(`${base.web_lab}/add_customer.php`, params)
  },
  // 市场人员查看完成订单finish_order.php
  seeFinishOrder(params) {
    return axios.post(`${base.web_lab}/finish_order.php`, params)
  },
  // 搜索订单 search_finish_order.php
  searchFinishOrder(params) {
    return axios.post(`${base.web_lab}/search_finish_order.php`, params)
  },
  // 搜索 公司 search_company.php
  searchCompany(params) {
    return axios.post(`${base.web_lab}/search_company.php`, params)
  },
  // 创建订单 create_order.php
  createOrder(params) {
    return axios.post(`${base.web_lab}/create_order.php`, params)
  },
  // 修改委托单信息
  updateOrderInfo(params) {
    return axios.post(`${base.web_lab}/update_order_info.php`, params)
  },
  // 创建订单搜索 get_device.php
  createSearchDevice(params) {
    return axios.post(`${base.web_lab}/get_device.php`, params)
  },
  //  订单添加仪器 create_order_detail.php
  orderAddDevice(params) {
    return axios.post(`${base.web_lab}/create_order_detail.php`, params)
  },
  // 委外未领订单详情
  seeUnworkOrderDetailOut(params) {
    return axios.post(`${base.web_lab}/work_order_detail_out.php`, params)
  },
  // 委外送检 和委外订单 需要选择实验室
  getLabs(params) {
    return axios.post(`${base.web_lab}/get_labs.php`, params)
  },
  // 未完成委托单 unfinished_order.php
  seeUnfinishedOrder(params) {
    return axios.post(`${base.web_lab}/unfinished_order.php`, params)
  },
  // 未完成委托单 search_unfinish_order.php
  searchUnfinishOrder(params) {
    return axios.post(`${base.web_lab}/search_unfinish_order.php`, params)
  },
  // 未完成委托单的删除 delete_order.php
  deleteUnfinishOrder(params) {
    return axios.post(`${base.web_lab}/delete_order.php`, params)
  },
  // 历史委托单 history_order.php
  seeHistoryOrder(params) {
    return axios.post(`${base.web_lab}/history_order.php`, params)
  },
  // 历史委托单 搜索 search_history_order.php
  searchHistoryOrder(params) {
    return axios.post(`${base.web_lab}/search_history_order.php`, params)
  },
  // 提醒委托单 remind_order.php
  remindOrder(params) {
    return axios.post(`${base.web_lab}/remind_order.php`, params)
  },
  // 提醒委托单搜索 search_remind_order.php
  searchRemind(params) {
    return axios.post(`${base.web_lab}/search_remind_order.php`, params)
  },
  // 查看订单详情order_detail.php
  orderDetail(params) {
    return axios.post(`${base.web_lab}/order_detail.php`, params)
  },
  // 点击 发样 /web_scan_qrcode.php
  scanQrcode(params) {
    return axios.post(`${base.web_lab}/web_scan_qrcode.php`, params)
  },
  // 删除 send_order.php
  sendOrder(params) {
    return axios.post(`${base.web_lab}/send_order.php`, params)
  },
  // 订单修改仪器 modify_order.php 保存
  updateOrderDevice(params) {
    return axios.post(`${base.web_lab}/modify_order.php`, params)
  },
  // 订单仪器删除 delete_order_device.php
  deleteOrderDevice(params) {
    return axios.post(`${base.web_lab}/delete_order_device.php`, params)
  },
  // 工程师查看订单 work_order.php
  seeUnworkOrder(params) {
    return axios.post(`${base.web_lab}/work_order.php`, params)
  },
  // 未领用订单详情 work_order_detail.php
  seeUnworkOrderDetail(params) {
    return axios.post(`${base.web_lab}/work_order_detail.php`, params)
  },
  // 工程师 未领订单的搜索 search_unfilled_order.php
  searchUnfilledOrder(params) {
    return axios.post(`${base.web_lab}/search_unfilled_order.php`, params)
  },
  // 工程师 确认领取仪器 receive_device.php'
  sureReceiveDevice(params) {
    return axios.post(`${base.web_lab}/receive_device.php`, params)
  },
  // 工程师查看 已领用订单 received_order.php
  seeReceivedOrder(params) {
    return axios.post(`${base.web_lab}/received_order.php`, params)
  },
  // 工程师委外 未领 委托单
  workOrderOut(params){
    return axios.post(`${base.web_lab}/work_order_out.php`, params)
  },
  // 工程师委外已领委托单
  ReceivedOrderOut(params) {
    return axios.post(`${base.web_lab}/received_order_out.php`, params)
  },
  // 工程师已领订单 搜索仪器 search_received_order.php
  searchReceivedOrder(params) {
    return axios.post(`${base.web_lab}/search_received_order.php`, params)
  },
  // 工程师查看已领用 received_device.php
  seeReceivedDeviceDetail(params) {
    return axios.post(`${base.web_lab}/received_device.php`, params)
  },
  // 查看委外已领订单
  seeReceivedDeviceDetailOut(params) {
    return axios.post(`${base.web_lab}/received_device_out.php`, params)
  },
  // 工程师已经订单 修改价格 modify_price.php
  updatePrice(params) {
    return axios.post(`${base.web_lab}/modify_price.php`, params)
  },
  // 获取同类仪器信息
  getSameDeviceInfo(params) {
    return axios.post(`${base.web_lab}/get_same_device_info.php`, params)
  },
  // 为外送检 完成
  sendOut(params) {
    return axios.post(`${base.web_lab}/out_finish.php`, params)
  },
  // 工程师已领单 修改规程 get_item_fp_equip.php
  updateDeviceRule(params) {
    return axios.post(`${base.web_lab}/get_item_fp_rule.php`, params)
  },
  // 工程师已领单 修改标准计量器具 get_item_fp_equip.php
  updateDeviceEquip(params) {
    return axios.post(`${base.web_lab}/get_item_fp_equip.php`, params)
  },
  // get_item_fp_rule.php
  // 工程师已领订单 修改规格保存 save_item_fp_rule.php
  updateDeviceSaveRule(params) {
    return axios.post(`${base.web_lab}/save_item_fp_rule.php`, params)
  },
  // 工程师已领订单 修改标准计量器具保存 save_item_fp_equip.php
  updateDeviceSaveEquip(params) {
    return axios.post(`${base.web_lab}/save_item_fp_equip.php`, params)
  },
  // 工程师证书模版选择 get_item_fp_templates.php
  getItemfpTemplates(params) {
    return axios.post(`${base.web_lab}/get_item_fp_templates.php`, params)
  },
  // 打开office 之前的接口
  officeFor(params){
    return axios.post(`${base.web_lab}/prepare_jl_office.php`, params)
  },
  // 工程师模版正常选择保存 save_item_fp_template.php
  saveItemfpTemplate(params) {
    return axios.post(`${base.web_lab}/save_item_fp_template.php`, params)
  },
  // 工程师已领仪器 参数录入完成 through_device.php
  throughDevice(params) {
    return axios.post(`${base.web_lab}/through_device.php`, params)
  },
  // 工程师核验订单查看 check_device.php
  checkDevice(params) {
    return axios.post(`${base.web_lab}/check_device.php`, params)
  },
  // 工程师批准订单查看 confirm_device.php
  confirmDevice(params) {
    return axios.post(`${base.web_lab}/confirm_device.php`, params)
  },
  // 工程师核验拒绝 通过 did_work_step2.php
  throughData(params) {
    return axios.post(`${base.web_lab}/did_work2.php`, params)
  },
  // 工程师批准通过 或者拒绝 did_work_step3.php
  throughConfirmDevice (params) {
    return axios.post(`${base.web_lab}/did_work3.php`, params)
  },
  // 工程师添加规程管理
  addRules(params) {
    return axios.post(`${base.web_lab}/add_rule.php`, params)
  },
  // 工程师 获取规程管理列表
  getRules(params) {
    return axios.post(`${base.web_lab}/get_rules.php`, params)
  },
  // 工程师 修改规程管理
  updateRules(params) {
    return axios.post(`${base.web_lab}/update_rule.php`, params)
  },
  // 工程师 删除规程管理
  deleteRules(params) {
    return axios.post(`${base.web_lab}/delete_rule.php`, params)
  },
  // 工程师能够做的能力
  userSkill(params) {
    return axios.post(`${base.web_lab}/get_user_skill_class.php`, params)
  },
  // 工程师标准器具管理获得列表
  getStdEquips(params) {
    return axios.post(`${base.web_lab}/get_std_equips.php`, params)
  },
  // 工程师标准器具管理获得列表
  getStdEquipsMonth(params) {
    return axios.post(`${base.web_lab}/get_std_equips_month.php`, params)
  },
  // 工程师标准器具管理 添加
  addStdEquip(params) {
    return axios.post(`${base.web_lab}/add_std_equip.php`, params)
  },
  // 工程师标准器具 修改
  updateStdEquip(params) {
    return axios.post(`${base.web_lab}/update_std_equip.php`, params)
  },
  // 工程师标准器具 删除
  deleteStdEquip(params) {
    return axios.post(`${base.web_lab}/delete_std_equip.php`, params)
  },  
  // 工程师添加模版证书搜索仪器 search_template_device.php
  searchTemplate(params) {
    return axios.post(`${base.web_lab}/search_template_device.php`, params)
  },
  // 工程师上传模版
  sendExcel(params) {
    return axios.post(`${base.web_lab}/add_template.php`, params, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  },
  // 获取模版列表
  getTemplate(params) {
    return axios.post(`${base.web_lab}/get_templates.php`, params)
  },
  // 模版修改 update_template.php
  updateTemplate(params) {
    return axios.post(`${base.web_lab}/update_template.php`, params)
  },
  // 模版删除
  deleteTemplate(params) {
    return axios.post(`${base.web_lab}/delete_template.php`, params)
  },
  // 证书生成 did_work1.php
  didWork(params) {
    return axios.post(`${base.web_lab}/did_work1.php`, params)
  },
  // 工程师 退样
  didWorkDel(params) {
    return axios.post(`${base.web_lab}/did_work0.php`, params)
  },
  // 工程师历史订单 engineer_history_order.php
  engineerHistory(params) {
    return axios.post(`${base.web_lab}/engineer_history_order.php`, params)
  },
  // 工程师历史订单搜索 search_engineer_history_order.php
  searchEngineerHistoryOrder(params) {
    return axios.post(`${base.web_lab}/search_engineer_history_order.php`, params)
  },
  //工程师历史订单查看详情 engineer_order_detail.php
  engineerOrderDetail(params) {
    return axios.post(`${base.web_lab}/engineer_order_detail.php`, params)
  },
  download(params) {
    return axios.post(`${base.web_lab}/download.php`, params, {
      // headers: {'Content-Type': 'multipart/form-data'}
      responseType: 'blob' // 下载的时候要求文件返回的类型
    })
  },
  engineerHandleRevert(params) {
    return axios.post(`${base.web_lab}/engineer_handle_revert.php`, params)
  },
  engineerSearchCert(params) {
    return axios.post(`${base.web_lab}/engineer_search_cert.php`, params)
  },
  // search_item_fp_rule.php 规程修改搜索
  searchItemFpRule(params) {
    return axios.post(`${base.web_lab}/search_item_fp_rule.php`, params)
  },
  // 规程搜索 search_rules.php
  searchRule(params) {
    return axios.post(`${base.web_lab}/search_rules.php`, params)
  },
  // 标准计量器具搜索 search_item_fpp_equip.php, device_type,search
  searchItemFpEquip(params) {
    return axios.post(`${base.web_lab}/search_item_fp_equip.php`, params)
  },
  searchEquip(params) {
    return axios.post(`${base.web_lab}/search_std_equips.php`, params)
  },
  getData(params) { // 手机查看证书
    return axios.post(`${base.web_lab}/check_jl_office.php`, params)/* qs.stringify( */
  },
  // 获取财务账户get_accountant.php
  getAccountant(params) {
    return axios.post(`${base.web_lab}/get_accountant.php`, params)
  },
  // 标准计量器具 添加溯源机构get_all_labs.php
  getAllLab(params) {
    return axios.post(`${base.web_lab}/get_all_labs.php`, params)
  },
  // 上传签名 upload_signature.php
  uploadSignature (params) {
    return axios.post(`${base.web_lab}/upload_signature.php`, params, {
      headers: {'Content-Type': 'multipart/form-data'}
    })
  },
  // 合同客户 未付费get_vip_financial.php
  getVipFinancial(params) {
    return axios.post(`${base.web_lab}/get_vip_financial.php`, params)
  },
  //合同客户 已付费
  getVipFinancialHistory(params) {
    return axios.post(`${base.web_lab}/get_vip_financial_history.php`, params)
  },
  // 财务修改保存 save_vip_receipt.php
  saveVipReceipt(params) {
    return axios.post(`${base.web_lab}/save_vip_receipt.php`, params)
  },
  // 普通客户 未付费 get_unpay_order.php
  getUnpayOrder(params) {
    return axios.post(`${base.web_lab}/get_unpay_order.php`, params)
  },
  // get_payed_order.php, 普通已付
  getPayedOrder(params) {
    return axios.post(`${base.web_lab}/get_payed_order.php`, params)
  },
  // save_order_receipt.php, 普通客户保存
  saveOrderReceipt(params) {
    return axios.post(`${base.web_lab}/save_order_receipt.php`, params)
  },
  //合同客户 未付费 搜索
  searchVipFinancial(params) {
    return axios.post(`${base.web_lab}/search_vip_financial.php`, params)
  },
  //合同客户 已付费 搜索
  searchVipFinancialHistory(params) {
    return axios.post(`${base.web_lab}/search_vip_financial_history.php`, params)
  },
  // 普通客户 未付费 搜索
  searchUnpayOrder(params) {
    return axios.post(`${base.web_lab}/search_unpay_order.php`, params)
  },
  // 搜索, 普通已付
  searchPayedOrder(params) {
    return axios.post(`${base.web_lab}/search_payed_order.php`, params)
  },
  // get_lab_cities.php 获取区域
  getLabCities(params) {
    return axios.post(`${base.web_lab}/get_lab_cities.php`, params)
  },
  // drop_device.php, item_id, type工程师 已领订单 放弃
  dropDevice(params) {
    return axios.post(`${base.web_lab}/drop_device.php`, params)
  },
  // 工程师已领订单 get_item_info.php, item_id,type 获取信息
  getItemInfo(params) {
    return axios.post(`${base.web_lab}/get_item_info.php`, params)
  },
  // save_item_info.php 工程师已领订单 保存信息修改
  saveItemInfo(params) {
    return axios.post(`${base.web_lab}/save_item_info.php`, params)
  },
  // 获取标准器具的类型
  getStdEquipType(params) {
    return axios.post(`${base.web_lab}/get_std_equip_type.php`, params)
  },
  // 获取全部仪器类型
  getAllDeviceType(params) {
    return axios.post(`${base.web_lab}/get_all_device_type.php`, params)
  },
};
export default service;